export default __webpack_public_path__ + "01eacd312f3d3a7cbbd53821871668ca.png";